import * as React from 'react';
import styled from 'styled-components';
import { noop } from 'utils/noop';
import { CleanLoadingCell } from './cells';
import { splitTableColumns } from './utils';

const PrimaryRow = styled.div`
  border-bottom: 1px solid #eaeaea;
  background: ${({ isSelected }) => (isSelected ? '#ecf6fa' : '#fcfcfc')};
`;

const LoadingRow = styled.div`
  padding: 40px;
`;

const DisplayActionCell = styled.div`
  max-width: 240px;
  width: 100%;
`;

// align-items: baseline enables a component to grow vertically without shifting the vertical position of the label
const Cell = styled.div`
  align-items: baseline;
  border-top: 1px solid #eff0f0;
  display: flex;
  justify-content: flex-start;
  padding: 10px 15px;
  word-break: normal;
  overflow-wrap: anywhere;
  background: transparent;
`;

const PrimaryCell = styled(Cell)`
  background: ${({ isSelected }) => (isSelected ? '#ecf6fa' : '#fff')};
`;

const Label = styled.div`
  color: #717171;
  flex: 0 0 auto;
  min-width: 130px;
  padding-right: 20px;
`;

const Display = styled.div`
  flex: 1 1 auto;
`;

// type Props = {
//   columns: TableColumn[],
//   primaryKey: string,
//   primaryValue: string,
//   rows: {}[],
//   isLoading?: boolean,
//   onSelectRow: () => {},
//   selectedRows: [],
// };

export const MobileTable = ({
  columns = [],
  primaryKey = 'name',
  primaryValue = '',
  rows,
  isLoading = false,
  onSelectRow = noop,
  selectedRows = [],
}) => {
  // break out the columns so we can reliably render the primary value up top
  // right now we don't need the `primaryCol` returned in the `[primaryCol, otherCols]` return
  const [_, otherCols] = splitTableColumns({
    columns,
    key: primaryKey,
    value: primaryValue,
  });

  return (
    <div id="mobile-table">
      {isLoading ? (
        <LoadingRow data-test="mobile-loading-row">
          <Display>
            <CleanLoadingCell />
          </Display>
        </LoadingRow>
      ) : (
        rows.map((row) => {
          const isSelected = selectedRows.includes(row);
          return (
            <PrimaryRow
              key={row.id}
              data-test={`mobile-row-${row.id}`}
              isSelected={isSelected}
              onClick={() => onSelectRow(row)}
            >
              <PrimaryCell id="primary-cell" isSelected={isSelected}>
                <strong>{row[primaryKey]}</strong>
              </PrimaryCell>
              {otherCols.map((col) => (
                <Cell key={col.value} data-test="mobile-cell">
                  {col.value !== 'actionCell' ? (
                    <React.Fragment>
                      <Label>{col.name}</Label>
                      <Display>{col.renderMobileCell(row, isSelected)}</Display>
                    </React.Fragment>
                  ) : (
                    <DisplayActionCell>{col.renderMobileCell(row, isSelected)}</DisplayActionCell>
                  )}
                </Cell>
              ))}
            </PrimaryRow>
          );
        })
      )}
    </div>
  );
};
